import { render, staticRenderFns } from "./merchant-details.vue?vue&type=template&id=f15a4990&scoped=true"
import script from "./merchant-details.ts?vue&type=script&lang=ts&external"
export * from "./merchant-details.ts?vue&type=script&lang=ts&external"
import style0 from "./merchant-details.scss?vue&type=style&index=0&id=f15a4990&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15a4990",
  null
  
)

export default component.exports